module.exports = require('./helpers/bundle-url').getBundleURL('01RMl') + "c.6842c356.png";